module.exports = __webpack_public_path__ + "static/media/fly0273.b985d4c5.webp";